var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHamburger = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 21 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.509 8.796H1.93c-.798 0-1.451.653-1.451 1.451 0 .799.653 1.452 1.451 1.452H19.51c.798 0 1.451-.653 1.451-1.452s-.639-1.451-1.451-1.451"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.931 2.903H19.51c.798 0 1.451-.653 1.451-1.452S20.307 0 19.509 0H1.93C1.133 0 .48.653.48 1.451c0 .799.653 1.452 1.451 1.452"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.509 17.577H1.93c-.798 0-1.451.653-1.451 1.452s.653 1.451 1.451 1.451H19.51c.798 0 1.451-.653 1.451-1.451 0-.799-.639-1.452-1.451-1.452"
  })));
};
export { SvgHamburger as ReactComponent };